import { render, staticRenderFns } from "./GlobalXpandModal.vue?vue&type=template&id=5b6644db&scoped=true&"
import script from "./GlobalXpandModal.vue?vue&type=script&lang=js&"
export * from "./GlobalXpandModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalXpandModal.vue?vue&type=style&index=0&id=5b6644db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6644db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6644db')) {
      api.createRecord('5b6644db', component.options)
    } else {
      api.reload('5b6644db', component.options)
    }
    module.hot.accept("./GlobalXpandModal.vue?vue&type=template&id=5b6644db&scoped=true&", function () {
      api.rerender('5b6644db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/GlobalXpandModal.vue"
export default component.exports